<template>
  <v-icon
    color="blue lighten-1"
    class="twitter-icon"
    v-text="'mdi-twitter'"
  />
</template>

<script>
export default {
  name: 'TwitterIcon',
};
</script>

<style lang="scss" scoped>
.twitter-icon {
  background-color: #fff;
  border-radius: 15px;
  font-size: 20px;
  padding: 2px;
}
</style>
